export const corsProxy = process.env.REACT_APP_CORS_PROXY;
export const ENV_URL = process.env.REACT_APP_ENV_URL;
export const BASE_URL = ENV_URL;
export const SKIPLY_MERCHANT_ID = process.env.REACT_APP_SKIPLY_MERCHANT_ID;
